import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HeaderWidgetComponent } from './header-widget.component';

@Component({
  template: `
    <div class="gridheader {{ header?.key }}">
      <span class="label" [innerHTML]="header?.label"></span>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./grid-header.component.scss']
})
export class GridHeaderComponent extends HeaderWidgetComponent {}
